export const translations = {
  kk: {
    nav: {
      home: 'Басты бет',
      qr: 'Карта',
      locations: 'Орындар',
      chat: 'Гид',
      history: 'Операциялар',
      profile: 'Профиль',
      navigation: 'Навигация',
      social_networks: 'Әлеуметтік желілер',
      information: 'Ақпарат',
      phone_number: '+7 777 830 75 88',
      address_city: 'Астана, Қазақстан',
      address_street: 'Жошы Хана 13',
      my_orders: 'Менің тапсырыстарым',
      track_order: 'Тапсырысты қадағалау',
      cart: 'Себет',
      back_to_main: 'Басты бетке',
      ecosystem_slogan: 'Қауіпсіз экожүйе'
    },
    home: {
      bonuses: 'Бонустар',
      store: {
        title: 'qaraa.store',
        subtitle: 'Онлайн дүкен',
        description: 'Сәнді киім сенікі',
        badge: '5 жаңа'
      },
      coffee: {
        title: 'qaraa.coffee',
        subtitle: 'Кофеханa',
        description: 'Жаңа кофе және жайлы орта',
        badge: 'Болашақта',
        soon: 'Кофеханa жақында ашылады!',
        closed_msg: 'Кіру жабық! Болашақта қолжетімді болады.'
      },
      news: {
        title: 'qaraa.news',
        subtitle: 'Жаңалықтар мен оқиғалар',
        description: 'Соңғы жаңартулардан хабардар болыңыз',
        badge: 'Болашақта'
      },
      user: 'Пайдаланушы',
      catalog_title: 'Тауарлар каталогы',
      catalog_subtitle: 'Барлық тауарлар қоймада бар.\nӨлшемдері әр тауардың жанында көрсетілген.',
      seller_on_duty: 'Бүгін ауысымда сатушы:',
      no_seller: 'ешкім тағайындалмаған',
      loading_products: 'Тауарлар жүктелуде...',
      barcode_label: 'Штрих-код:',
      order_btn: 'Тапсырыс беру',
      no_products_title: 'Тауарлар жақында пайда болады',
      no_products_desc: 'Біз каталогты толтыру үстіндеміз',
      select_size: 'Өлшемді таңдаңыз',
      in_stock: 'Қоймада бар:',
      cart_pill: 'Себетке',
      go_to_cart: 'Себетке өту',
      add: 'Қосу',
      add: 'Қосу',
      add_to_cart: 'Себетке қосу'
    },
    cart: {
      title: 'Себет',
      description: 'Мұнда сіз қосқан тауарлар пайда болады.',
      empty_title: 'Себетіңіз бос',
      empty_desc: 'Тауарларды қосу үшін каталогқа өтіңіз',
      order_summary: 'Тапсырыс сомасы',
      checkout: 'Рәсімдеу',
      total: 'Барлығы',
      size: 'Өлшем',
      in_stock: 'Қоймада',
      pcs: 'дана',
      delete: 'Жою',
      clear: 'Себетті тазалау',
      barcode: 'Штрих-код',
      barcode: 'Штрих-код',
      to_pay: 'Төлемге өту',
      checkout_title: 'Тапсырысты рәсімдеу',
      step_1_of_2: 'Қадам 1/2',
      step_2_of_2: 'Қадам 2/2',
      step_1_title: '1-қадам: Банк картасын тіркеу',
      bind_card_title: 'Банк картасын тіркеу',
      integration_msg: 'Мұнда Kaspi және басқа банктермен интеграция болады.',
      delivery_msg: 'Әзірге жеткізуді таңдауға өтіңіз.',
      cancel: 'Бас тарту',
      next: 'Келесі',
      step_2_title: '2-қадам: Жеткізу әдісі',
      choose_delivery: 'Жеткізу әдісін таңдаңыз:',
      delivery_kz: 'Қазақстан бойынша жеткізу',
      delivery_city: 'Қала бойынша жеткізу',
      pickup: 'Өз бетінше алып кету',
      free: 'ТЕГІН',
      temp_unavailable: 'Уақытша қолжетімсіз',
      soon_badge: 'Жақында',
      pickup_address: 'Астана, Жошы Хана 13',
      who_pickup: 'Тапсырысты кім алады?',
      pickup_me: 'Өзім алып кетемін',
      pickup_me_desc: 'Профиль деректері қолданылады',
      pickup_other: 'Басқа алушы',
      pickup_other_desc: 'Алушының деректерін көрсетіңіз',
      pickup_addr_title: 'Алып кету мекенжайы',
      pickup_loc_city: 'Астана, Қазақстан',
      pickup_loc_street: 'Жошы Хана 13',
      delivery_calc_msg: 'Жеткізу құны нақтылануда. Есептеу үшін бізге жазыңыз.',
      form_name: 'Есімі',
      form_surname: 'Тегі',
      form_middlename: 'Әкесінің аты',
      form_phone: 'Телефон нөмірі',
      form_city: 'Қала/Ауыл',
      form_street: 'Көше',
      form_house: 'Үй',
      form_apt: 'Пәтер',
      form_zip: 'Пошта индексі',
      form_address: 'Мекенжай',
      form_recipient_phone: 'Алушының телефоны',
      form_entrance: 'Кіреберіс',
      form_apt_office: 'Пәтер/кеңсе',
      form_floor: 'Қабат',
      form_intercom: 'Домофон',
      form_comment: 'Пікір',
      pay_btn: 'Төлеу',
      bonus_program_title: 'Бонус бағдарламасы',
      bonus_program_desc_1: 'Өз бетінше алып кету кезінде тек бонус картасы қажет.',
      bonus_program_bold: 'Сомадан 5% бонустар',
      bonus_program_desc_2: 'кассада сканерлегеннен кейін түседі.',
      pay_title: 'Төлем жасаңыз',
      recipient_name: 'Серік С.',
      pay_instruction_1: 'Жоғарыда көрсетілген әдіспен төлеңіз, төлегеннен кейін «',
      paid_btn: 'Төледім',
      pay_instruction_2: '» түймесін басып, сатушының растауын күтіңіз. Тапсырысты «Тапсырысты қадағалау» бөлімінде бақылаңыз',
      to_pay_title: 'Төлем сомасы:',
      include_delivery: '(2000 ₸ жеткізуді қоса алғанда)',
      bonus_program_footer: 'Тапсырысты беру кезінде тауар сомасынан 5% бонус есептеледі',
      // Validation & Success
      error_only_letters: 'Тек әріптер',
      error_phone_format: 'Нөмір: 10 цифр (+7 кейін)',
      error_city_letters: 'Қала: тек әріптер',
      error_street_required: 'Көше міндетті',
      error_only_digits: 'Тек цифрлар',
      error_zip_format: '6 цифр',
      error_required: 'Міндетті өріс',
      error_intercom_format: 'Тек цифрлар және #,*',
      success_title: 'Сатып алғаныңызға рахмет! 💌',
      success_desc_1: 'Сатушы тапсырысыңызды жақында растайды.',
      success_desc_2: 'Тапсырысты «Тапсырысты қадағалау» бөлімінде бақылай аласыз.',
      success_sign: '— ізгі ниетпен, qaraa командасы',
      success_track_btn: '📍 Тапсырысты қадағалау',
      success_close_btn: 'Жабу',
      // Confirmation Modal
      confirm_delete_title: 'Тауарды жою?',
      confirm_delete_desc: 'Бұл әрекетті қайтару мүмкін емес',
      confirm_clear_title: 'Себетті тазалау?',
      confirm_clear_desc: 'Барлық тауарлар жойылады',
      confirm_cancel: 'Болдырмау',
      confirm_delete: 'Жою',
      toast_deleted: 'Жойылды',
      toast_cleared: 'Себет тазаланды'
    },
    profile: {
      language: 'Тіл',
      settings: 'Параметрлер',
      logout: 'Шығу',
      title: 'Профиль',
      user: 'Пайдаланушы',
      select_language: 'Тілді таңдаңыз',
      logout_confirm_title: 'Есептік жазбадан шығу керек пе?',
      logout_confirm_msg: 'Шынымен шыққыңыз келе ме? Жүйеге қайта кіруіңіз керек болады.',
      reg_date: 'Тіркелген күні',
      birth_date: 'Туған күні',
      first_name: 'Есімі',
      last_name: 'Тегі',
      middle_name: 'Әкесінің аты'
    },
    wallet: {
      add: 'Apple Wallet-ке қосу',
      soon: 'Apple Wallet-ке қосу жақында қолжетімді болады'
    },
    common: {
      good_night: 'Қайырлы түн',
      open: 'Ашу',
      cancel: 'Бас тарту',
      close: 'Жабу',
      item: 'Тауар',
      status: 'Мәртебе',
      reason: 'Себебі',
      delivery_label: 'Жеткізу',
      system: 'Жүйе',
      order_no: 'Тапсырыс №'
    },
    greet: {
      morning: 'Қайырлы таң',
      day: 'Қайырлы күн',
      evening: 'Қайырлы кеш',
      night: 'Қайырлы түн',
      hello: 'Сәлем'
    },
    programs: {
      title: 'Сіздің бағдарламаларыңыз',
      subtitle: 'Адалдық бағдарламасын таңдаңыз'
    },
    card: {
      clickForBarcode: 'Штрих-код үшін басыңыз',
      clickForQR: 'QR-код үшін басыңыз'
    },
    support: {
      title: 'Қолдау',
      description: 'Көмек алу үшін Telegram арқылы бізге хабарласыңыз',
      open_tg: 'Telegram-ды ашу',
      close: 'Жабу'
    },
    security: {
      title: 'Қауіпсіздік орталығы',
      change_password: 'Құпия сөзді өзгерту',
      current_password: 'Ағымдағы құпия сөз',
      new_password: 'Жаңа құпия сөз',
      confirm_password: 'Құпия сөзді растау',
      update_btn: 'Жаңарту',
      success: 'Құпия сөз сәтті өзгертілді',
      error: 'Қате орын алды',
      session_expired: 'Пайдаланушы табылмады немесе сессия аяқталды',
      incorrect_password: 'Ағымдағы құпия сөз дұрыс емес',
      passwords_mismatch: 'Құпия сөздер сәйкес келмейді',
      password_too_short: 'Құпия сөз тым қысқа'
    },
    gestures: {
      swipe_up: 'Төлем жасау үшін жоғары сүйреңіз'
    },
    locations: {
      search: 'Орындарды іздеу...'
    },
    history: {
      title: 'Тапсырыстар тарихы',
      loading: 'Тапсырыстар жүктелуде...',
      empty_title: 'Әзірге бос',
      empty_desc: 'Мұнда сіздің тапсырыстарыңыз пайда болады',
      order_no: 'Тапсырыс №',
      items_count: 'Тауарлар саны:',
      show_more: 'Тағы көрсету',
      details: 'Толығырақ',
      last_action: 'Соңғы әрекет:',
      reason: 'Бас тарту себебі:',
      logout_confirm: 'Шығуды растау',
      status: {
        created: 'Құрылды',
        accepted: 'Қабылданды',
        packing: 'Қаптау',
        ready: 'Дайын',
        issued: 'Берілді',
        canceled: 'Бас тартылды'
      },
      delivery: {
        prefix_delivery: 'Жеткізу',
        prefix_pickup: 'Алу',
        method_kz: 'Қазақстан бойынша',
        method_city: 'Қала бойынша',
        method_store: 'Дүкенде',
        method_pickup: 'Өз бетінше алып кету'
      }
    },
    track: {
      title: 'Тапсырысты қадағалау',
      description: 'Белсенді тапсырыстарыңыздың күйін нақты уақыт режимінде бақылаңыз',
      my_orders: 'Менің тапсырыстарым',
      status_history: 'Күйлер тарихы',
      empty_title: 'Белсенді тапсырыстар жоқ',
      empty_desc: 'Белсенді тапсырыстар мұнда пайда болады',
      loading_history: 'Тарих жүктелуде...',
      no_events_title: 'Әзірге оқиғалар жоқ',
      no_events_desc: 'Тарих мұнда пайда болады',
      loading_orders: 'Тапсырыстар жүктелуде...',
      select_order_title: 'Тапсырысты таңдаңыз',
      select_order_desc_desktop: 'Толық мәртебелер тарихын көру үшін\nсол жақтан тапсырысты таңдаңыз',
      select_order_desc_mobile: 'Толық мәртебелер тарихын көру үшін\nжоғарыдан тапсырысты таңдаңыз'
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      qr: 'Карта',
      locations: 'Места',
      chat: 'Гид',
      history: 'История',
      profile: 'Профиль',
      navigation: 'Навигация',
      social_networks: 'Социальные сети',
      information: 'Информация',
      phone_number: '+7 777 830 75 88',
      address_city: 'Астана, Казахстан',
      address_street: 'Жошы Хана 13',
      my_orders: 'Мои заказы',
      track_order: 'Отследить заказ',
      cart: 'Корзина',
      back_to_main: 'На главную',
      ecosystem_slogan: 'Безопасная экосистема'
    },
    home: {
      bonuses: 'Бонусы',
      store: {
        title: 'qaraa.store',
        subtitle: 'Онлайн магазин',
        description: 'Стильная одежда для тебя',
        badge: '5 новых'
      },
      coffee: {
        title: 'qaraa.coffee',
        subtitle: 'Кофейня',
        description: 'Свежий кофе и уютная атмосфера',
        badge: 'В будущем',
        soon: 'Кофейня скоро откроется!',
        closed_msg: 'Вход закрыт! Будет доступно в будущем.'
      },
      news: {
        title: 'qaraa.news',
        subtitle: 'Новости и события',
        description: 'Будьте в курсе последних обновлений',
        badge: 'В будущем'
      },
      user: 'Пользователь',
      catalog_title: 'Каталог товаров',
      catalog_subtitle: 'Всё, что вы видите — у нас в наличии.\nРазмеры указаны рядом с каждый товаром.',
      seller_on_duty: 'Сегодня в смене продавец:',
      no_seller: 'никто не назначен',
      loading_products: 'Загрузка товаров...',
      barcode_label: 'Штрихкод:',
      order_btn: 'Заказать',
      no_products_title: 'Товары скоро появятся',
      no_products_desc: 'Мы работаем над пополнением каталога',
      select_size: 'Выберите размер',
      in_stock: 'В наличии:',
      cart_pill: 'В корзину',
      go_to_cart: 'Перейти в корзину',
      add: 'Добавить',
      add: 'Добавить',
      add_to_cart: 'Добавить в корзину'
    },
    cart: {
      title: 'Корзина',
      description: 'Здесь появятся товары, которые вы добавили.',
      empty_title: 'Ваша корзина пуста',
      empty_desc: 'Перейдите в каталог, чтобы добавить товары',
      order_summary: 'Сумма заказа',
      checkout: 'Оформить заказ',
      total: 'Итого',
      size: 'Размер',
      in_stock: 'В наличии',
      pcs: 'шт.',
      delete: 'Удалить',
      clear: 'Очистить корзину',
      barcode: 'Штрих-код',
      barcode: 'Штрих-код',
      to_pay: 'Перейти к оплате',
      checkout_title: 'Оформление заказа',
      step_1_of_2: 'Шаг 1 из 2',
      step_2_of_2: 'Шаг 2 из 2',
      step_1_title: 'Шаг 1 из 2: Привязка банковской карты',
      bind_card_title: 'Привязка банковской карты',
      integration_msg: 'Здесь будет интеграция с Kaspi и другими банками.',
      delivery_msg: 'Пока что переходите к выбору доставки.',
      cancel: 'Отмена',
      next: 'Далее',
      step_2_title: 'Шаг 2 из 2: Способ доставки',
      choose_delivery: 'Выберите способ доставки:',
      delivery_kz: 'Доставка по Казахстану',
      delivery_city: 'Доставка по городу',
      pickup: 'Самовывоз',
      free: 'БЕСПЛАТНО',
      temp_unavailable: 'Временно недоступно',
      soon_badge: 'Скоро',
      pickup_address: 'Астана, Жошы Хана 13',
      who_pickup: 'Кто будет забирать заказ?',
      pickup_me: 'Я заберу сам',
      pickup_me_desc: 'Используются данные из профиля',
      pickup_other: 'Другой получатель',
      pickup_other_desc: 'Укажите данные получателя',
      pickup_addr_title: 'Адрес самовывоза',
      pickup_loc_city: 'Астана, Казахстан',
      pickup_loc_street: 'Жошы Хана 13',
      delivery_calc_msg: 'Стоимость доставки уточняется. Напишите нам для расчёта.',
      form_name: 'Имя',
      form_surname: 'Фамилия',
      form_middlename: 'Отчество',
      form_phone: 'Номер телефона',
      form_city: 'Город/Село',
      form_street: 'Улица',
      form_house: 'Дом',
      form_apt: 'Квартира',
      form_zip: 'Почтовый индекс',
      form_address: 'Адрес',
      form_recipient_phone: 'Телефон получателя',
      form_entrance: 'Подъезд',
      form_apt_office: 'Квартира/офис',
      form_floor: 'Этаж',
      form_intercom: 'Домофон',
      form_comment: 'Комментарий',
      pay_btn: 'Оплатить',
      bonus_program_title: 'Бонусная программа',
      bonus_program_desc_1: 'При самовывозе требуется только бонусная карта.',
      bonus_program_bold: 'Бонусы 5% от суммы',
      bonus_program_desc_2: 'начисляются после сканирования на кассе.',
      pay_title: 'Сделайте оплату',
      recipient_name: 'Серик С.',
      pay_instruction_1: 'Оплатите по вышеуказанному способу оплаты, после оплаты нажмите кнопку «',
      paid_btn: 'Оплатил',
      pay_instruction_2: '» ожидайте подтверждения продавца. За заказом можете следить в разделе «Отследить заказ»',
      to_pay_title: 'К оплате:',
      include_delivery: '(включая доставку 2000 ₸)',
      bonus_program_footer: 'Бонусы 5% от суммы товара начисляются при выдаче заказа',
      // Validation & Success
      error_only_letters: 'Только буквы',
      error_phone_format: 'Номер: 10 цифр (после +7)',
      error_city_letters: 'Город: только буквы',
      error_street_required: 'Улица обязательна',
      error_only_digits: 'Только цифры',
      error_zip_format: '6 цифр',
      error_required: 'Обязательное поле',
      error_intercom_format: 'Только цифры и #,*',
      success_title: 'Спасибо за покупку! 💌',
      success_desc_1: 'Продавец скоро подтвердит ваш заказ.',
      success_desc_2: 'Вы можете отслеживать заказ в разделе «Отследить заказ».',
      success_sign: '— с любовью, команда qaraa',
      success_track_btn: '📍 Отследить заказ',
      success_close_btn: 'Закрыть',
      // Confirmation Modal
      confirm_delete_title: 'Удалить товар?',
      confirm_delete_desc: 'Это действие нельзя отменить',
      confirm_clear_title: 'Очистить корзину?',
      confirm_clear_desc: 'Все товары будут удалены',
      confirm_cancel: 'Отмена',
      confirm_delete: 'Удалить',
      toast_deleted: 'Удалено',
      toast_cleared: 'Корзина очищена'
    },
    profile: {
      language: 'Язык',
      settings: 'Настройки',
      logout: 'Выйти',
      title: 'Профиль',
      user: 'Пользователь',
      select_language: 'Выберите язык',
      logout_confirm_title: 'Выйти из аккаунта?',
      logout_confirm_msg: 'Вы уверены, что хотите выйти? Вам придется снова войти в систему.',
      reg_date: 'Дата регистрации',
      birth_date: 'Дата рождения',
      first_name: 'Имя',
      last_name: 'Фамилия',
      middle_name: 'Отчество'
    },
    wallet: {
      add: 'Добавить в Apple Wallet',
      soon: 'Функция добавления в Apple Wallet будет доступна скоро'
    },
    common: {
      good_night: 'Спокойной ночи',
      open: 'Открыть',
      cancel: 'Отмена',
      close: 'Закрыть',
      item: 'Товар',
      status: 'Статус',
      reason: 'Причина',
      delivery_label: 'Доставка',
      system: 'Система',
      order_no: 'Заказ №'
    },
    greet: {
      morning: 'Доброе утро',
      day: 'Добрый день',
      evening: 'Добрый вечер',
      night: 'Спокойной ночи',
      hello: 'Привет'
    },
    programs: {
      title: 'Ваши программы',
      subtitle: 'Выберите программу лояльности'
    },
    card: {
      clickForBarcode: 'Нажмите для QR-кода',
      clickForQR: 'Нажмите для штрих-кода'
    },
    support: {
      title: 'Поддержка',
      description: 'Свяжитесь с нами в Telegram для получения помощи',
      open_tg: 'Открыть Telegram',
      close: 'Закрыть'
    },
    security: {
      title: 'Центр безопасности',
      change_password: 'Изменить пароль',
      current_password: 'Текущий пароль',
      new_password: 'Новый пароль',
      confirm_password: 'Подтвердите пароль',
      update_btn: 'Обновить',
      success: 'Пароль успешно изменен',
      error: 'Произошла ошибка',
      session_expired: 'Пользователь не найден или сессия истекла',
      incorrect_password: 'Неверный текущий пароль',
      passwords_mismatch: 'Пароли не совпадают',
      password_too_short: 'Пароль слишком короткий'
    },
    gestures: {
      swipe_up: 'Смахните вверх, чтобы оплатить'
    },
    locations: {
      search: 'Поиск мест...'
    },
    history: {
      title: 'История заказов',
      loading: 'Загрузка заказов...',
      empty_title: 'Пока пусто',
      empty_desc: 'Здесь появятся ваши заказы',
      order_no: 'Заказ №',
      items_count: 'Товаров:',
      show_more: 'Показать еще',
      details: 'Детали',
      last_action: 'Последнее действие:',
      reason: 'Причина отмены:',
      logout_confirm: 'Подтверждение выхода',
      status: {
        created: 'Создан',
        accepted: 'Принято',
        packing: 'Упаковка',
        ready: 'Готово',
        issued: 'Выдано',
        canceled: 'Отменён'
      },
      delivery: {
        prefix_delivery: 'Доставка',
        prefix_pickup: 'Получение',
        method_kz: 'по KZ',
        method_city: 'по городу',
        method_store: 'в магазине',
        method_pickup: 'самовывоз'
      }
    },
    track: {
      title: 'Отслеживание заказа',
      description: 'Отслеживайте статус ваших активных заказов в реальном времени',
      my_orders: 'Мои заказы',
      status_history: 'История статусов',
      empty_title: 'Нет активных заказов',
      empty_desc: 'Активные заказы появятся здесь',
      loading_history: 'Загрузка истории...',
      no_events_title: 'Пока нет событий',
      no_events_desc: 'История появится здесь',
      loading_orders: 'Загрузка заказов...',
      select_order_title: 'Выберите заказ',
      select_order_desc_desktop: 'Выберите заказ слева, чтобы увидеть\nподробную историю статусов',
      select_order_desc_mobile: 'Выберите заказ выше, чтобы увидеть\nподробную историю статусов'
    }
  },
  en: {
    nav: {
      home: 'Home',
      qr: 'Card',
      locations: 'Places',
      chat: 'Guide',
      history: 'History',
      profile: 'Profile',
      navigation: 'Navigation',
      social_networks: 'Social Networks',
      information: 'Information',
      phone_number: '+7 777 830 75 88',
      address_city: 'Astana, Kazakhstan',
      address_street: 'Zhoshy Khan 13',
      my_orders: 'My Orders',
      track_order: 'Track Order',
      cart: 'Cart',
      back_to_main: 'Back to main',
      ecosystem_slogan: 'Secure Ecosystem'
    },
    home: {
      bonuses: 'Bonuses',
      store: {
        title: 'qaraa.store',
        subtitle: 'Online store',
        description: 'Stylish clothes for you',
        badge: '5 new'
      },
      coffee: {
        title: 'qaraa.coffee',
        subtitle: 'Coffee shop',
        description: 'Fresh coffee and cozy atmosphere',
        badge: 'In the future',
        soon: 'Coffee shop will open soon!',
        closed_msg: 'Admission is closed! It will be available in the future.'
      },
      news: {
        title: 'qaraa.news',
        subtitle: 'News and events',
        description: 'Stay updated with our latest news',
        badge: 'In the future'
      },
      user: 'User',
      catalog_title: 'Product Catalog',
      catalog_subtitle: 'Everything you see is in stock.\nSizes are listed next to each item.',
      seller_on_duty: 'Seller on duty today:',
      no_seller: 'no one assigned',
      loading_products: 'Loading products...',
      barcode_label: 'Barcode:',
      order_btn: 'Order',
      no_products_title: 'Products coming soon',
      no_products_desc: 'We are working on replenishing the catalog',
      select_size: 'Select size',
      in_stock: 'In stock:',
      cart_pill: 'To Cart',
      go_to_cart: 'Go to Cart',
      add: 'Add',
      add: 'Add',
      add_to_cart: 'Add to Cart'
    },
    cart: {
      title: 'Cart',
      description: 'Items you added will appear here.',
      empty_title: 'Your cart is empty',
      empty_desc: 'Go to catalog to add items',
      order_summary: 'Order Total',
      checkout: 'Checkout',
      total: 'Total',
      size: 'Size',
      in_stock: 'In stock',
      pcs: 'pcs',
      delete: 'Delete',
      clear: 'Clear Cart',
      barcode: 'Barcode',
      barcode: 'Barcode',
      to_pay: 'Proceed to checkout',
      checkout_title: 'Checkout',
      step_1_of_2: 'Step 1 of 2',
      step_2_of_2: 'Step 2 of 2',
      step_1_title: 'Step 1 of 2: Link Bank Card',
      bind_card_title: 'Link Bank Card',
      integration_msg: 'Integration with Kaspi and other banks will be here.',
      delivery_msg: 'For now, proceed to delivery selection.',
      cancel: 'Cancel',
      next: 'Next',
      step_2_title: 'Step 2 of 2: Delivery Method',
      choose_delivery: 'Choose delivery method:',
      delivery_kz: 'Delivery across Kazakhstan',
      delivery_city: 'City Delivery',
      pickup: 'Pickup',
      free: 'FREE',
      temp_unavailable: 'Temporarily unavailable',
      soon_badge: 'Soon',
      pickup_address: 'Astana, Zhoshy Khan 13',
      who_pickup: 'Who will pick up the order?',
      pickup_me: 'I will pick it up myself',
      pickup_me_desc: 'Profile data is used',
      pickup_other: 'Another recipient',
      pickup_other_desc: 'Specify recipient details',
      pickup_addr_title: 'Pickup address',
      pickup_loc_city: 'Astana, Kazakhstan',
      pickup_loc_street: 'Zhoshy Khan 13',
      delivery_calc_msg: 'Delivery cost is being calculated. Write to us for calculation.',
      form_name: 'First Name',
      form_surname: 'Last Name',
      form_middlename: 'Middle Name',
      form_phone: 'Phone Number',
      form_city: 'City/Village',
      form_street: 'Street',
      form_house: 'House',
      form_apt: 'Apartment',
      form_zip: 'Postal Code',
      form_address: 'Address',
      form_recipient_phone: 'Recipient Phone',
      form_entrance: 'Entrance',
      form_apt_office: 'Apt/Office',
      form_floor: 'Floor',
      form_intercom: 'Intercom',
      form_comment: 'Comment',
      pay_btn: 'Pay',
      bonus_program_title: 'Bonus Program',
      bonus_program_desc_1: 'Only bonus card is needed for pickup.',
      bonus_program_bold: '5% bonuses',
      bonus_program_desc_2: 'are credited after scanning at the checkout.',
      pay_title: 'Make Payment',
      recipient_name: 'Serik S.',
      pay_instruction_1: 'Pay using the method above, then press "',
      paid_btn: 'Paid',
      pay_instruction_2: '" and wait for seller confirmation. Track your order in "Track Order" section',
      to_pay_title: 'To Pay:',
      include_delivery: '(including 2000 ₸ delivery)',
      bonus_program_footer: '5% bonuses from item total are credited upon order pickup',
      // Validation & Success
      error_only_letters: 'Only letters',
      error_phone_format: 'Number: 10 digits (after +7)',
      error_city_letters: 'City: only letters',
      error_street_required: 'Street is required',
      error_only_digits: 'Only digits',
      error_zip_format: '6 digits',
      error_required: 'Required field',
      error_intercom_format: 'Only digits and #,*',
      success_title: 'Thank you for your purchase! 💌',
      success_desc_1: 'The seller will confirm your order soon.',
      success_desc_2: 'You can track your order in the "Track Order" section.',
      success_sign: '— with love, qaraa team',
      success_track_btn: '📍 Track Order',
      success_close_btn: 'Close',
      // Confirmation Modal
      confirm_delete_title: 'Delete item?',
      confirm_delete_desc: 'This action cannot be undone',
      confirm_clear_title: 'Clear cart?',
      confirm_clear_desc: 'All items will be removed',
      confirm_cancel: 'Cancel',
      confirm_delete: 'Delete',
      toast_deleted: 'Deleted',
      toast_cleared: 'Cart cleared'
    },
    profile: {
      language: 'Language',
      settings: 'Settings',
      logout: 'Log out',
      title: 'Profile',
      user: 'User',
      select_language: 'Select Language',
      logout_confirm_title: 'Log out of account?',
      logout_confirm_msg: 'Are you sure you want to log out? You will need to log in again.',
      reg_date: 'Registration Date',
      birth_date: 'Date of Birth',
      first_name: 'First Name',
      last_name: 'Last Name',
      middle_name: 'Middle Name'
    },
    wallet: {
      add: 'Add to Apple Wallet',
      soon: 'Adding to Apple Wallet will be available soon'
    },
    common: {
      good_night: 'Good night',
      open: 'Open',
      cancel: 'Cancel',
      close: 'Close',
      item: 'Item',
      status: 'Status',
      reason: 'Reason',
      delivery_label: 'Delivery',
      system: 'System',
      order_no: 'Order No'
    },
    greet: {
      morning: 'Good morning',
      day: 'Good afternoon',
      evening: 'Good evening',
      night: 'Good night',
      hello: 'Hello'
    },
    programs: {
      title: 'Your programs',
      subtitle: 'Choose loyalty program'
    },
    card: {
      clickForBarcode: 'Click for QR code',
      clickForQR: 'Click for barcode'
    },
    support: {
      title: 'Support',
      description: 'Contact us on Telegram for assistance',
      open_tg: 'Open Telegram',
      close: 'Close'
    },
    security: {
      title: 'Security Center',
      change_password: 'Change Password',
      current_password: 'Current Password',
      new_password: 'New Password',
      confirm_password: 'Confirm Password',
      update_btn: 'Update',
      success: 'Password updated successfully',
      error: 'An error occurred',
      session_expired: 'User not found or session expired',
      incorrect_password: 'Incorrect current password',
      passwords_mismatch: 'Passwords do not match',
      password_too_short: 'Password is too short'
    },
    gestures: {
      swipe_up: 'Swipe up to pay'
    },
    locations: {
      search: 'Search places...'
    },
    history: {
      title: 'Order History',
      loading: 'Loading orders...',
      empty_title: 'Empty',
      empty_desc: 'Your orders will appear here',
      order_no: 'Order #',
      items_count: 'Items:',
      show_more: 'Show more',
      details: 'Details',
      last_action: 'Last action:',
      reason: 'Cancellation reason:',
      logout_confirm: 'Logout confirmation',
      status: {
        created: 'Created',
        accepted: 'Accepted',
        packing: 'Packing',
        ready: 'Ready',
        issued: 'Issued',
        canceled: 'Canceled'
      },
      delivery: {
        prefix_delivery: 'Delivery',
        prefix_pickup: 'Pickup',
        method_kz: 'across KZ',
        method_city: 'citywide',
        method_store: 'in store',
        method_pickup: 'pickup'
      }
    },
    track: {
      title: 'Track Order',
      description: 'Follow the status of your active orders in real time',
      my_orders: 'My Orders',
      status_history: 'Status History',
      empty_title: 'No active orders',
      empty_desc: 'Active orders will appear here',
      loading_history: 'Loading history...',
      no_events_title: 'No events yet',
      no_events_desc: 'History will appear here',
      loading_orders: 'Loading orders...',
      select_order_title: 'Select an order',
      select_order_desc_desktop: 'Select an order from the left to see\na detailed status history',
      select_order_desc_mobile: 'Select an order from above to see\na detailed status history'
    }
  }
};